module.exports = __webpack_public_path__ + "static/media/recordatorio.915a25da.png";